"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.ThemeProvider = exports.DEFAULT_THEME = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("@emotion/react");
var cache_1 = __importDefault(require("@emotion/cache"));
var default_theme_1 = __importDefault(require("./theme/default-theme"));
exports.DEFAULT_THEME = default_theme_1.default;
var ThemeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? exports.DEFAULT_THEME : _b, nonce = _a.nonce, children = _a.children, props = __rest(_a, ["theme", "nonce", "children"]);
    var cache = react_1.useMemo(function () { return cache_1.default({
        key: 'sixsense-core',
        nonce: nonce,
    }); }, [nonce]);
    return (react_1.default.createElement(react_2.CacheProvider, { value: cache },
        react_1.default.createElement(react_2.ThemeProvider, __assign({ theme: theme }, props),
            react_1.default.createElement(react_2.Global, { styles: theme.global }),
            children)));
};
exports.ThemeProvider = ThemeProvider;
exports.useTheme = react_2.useTheme;
/**
 * * Spacing System *
 * * assuming BASE_SIZE = 1rem = 16px
 */
// name     rem           px
// * 0      0             0px
// * 1      0.25rem       4px
// * 2      0.5rem        8px
// * 3      0.75rem       12px
// * 4      1rem          16px
// * 5      1.25rem       20px
// * 6      1.5rem        24px
// * 8      2rem          32px
// * 10     2.5rem        40px
// * 12     3rem          48px
// * 16     4rem          64px
// * 20     5rem          80px
// * 24     6rem          96px
// * 32     8rem          128px
// * 40     10rem         160px
// * 48     12rem         192px
// * 56     14rem         224px
// * 64     16rem         256px
